export const COLORS = {
    red: "#FD0014",
    white: "#fff",
    lightgray:"#505050",
    blue: "#030762",
    gray:"#DFDFDF",
    darkblue:"#070E4A"
    

    
}

export const SIZES = {
    h3: "48px",
    h4: "36px",
    h5: "16px",
    h6: "14px",
    padding: "100px"
}

